

































import Vue from "vue";
export default Vue.extend({
  name: "ErrorCard",

  props: {
    title: {
      type: String,
      required: false,
      default: "Błąd"
    },

    message: {
      type: String,
      required: false,
      default: ""
    }
  }
});
